import { FULL_DAY_MILLISECONDS } from "web/Pages/Checkout/Subscription/BenefitSummary/ActiveForm/constants";

import { DuplicateStatus } from "web/constants/benefits";

const isThatMoreThanEraForDuplicate = (
  lastSportCardRequestAt?: string,
  enableOrderDuplicateCard?: boolean
) => {
  if (!enableOrderDuplicateCard) return DuplicateStatus.DUPLICATE_UNAVAILABLE;
  if (!lastSportCardRequestAt) return DuplicateStatus.NEVER_ORDERED;

  const currentData = new Date().getTime();
  const lastSportCardRequestAtMiliseconds = new Date(
    lastSportCardRequestAt
  ).getTime();

  return currentData - lastSportCardRequestAtMiliseconds > FULL_DAY_MILLISECONDS
    ? DuplicateStatus.NEVER_ORDERED
    : DuplicateStatus.ALREADY_ORDERED;
};

export default isThatMoreThanEraForDuplicate;
